/**
 * Product Type Configuration
 * ============================================================
 * This file is the SINGLE source of truth for the Type / Category / Sub Category
 * hierarchy used in the Product Dashboard table and the Dashboard Global Footprint filters.
 *
 * HOW TO EDIT:
 *  - To ADD a new type:       Add a new top-level key inside PRODUCT_TYPE_CONFIG.
 *  - To ADD a new category:   Add a new key under the relevant type.
 *  - To ADD a sub-category:   Push a string value into the relevant category array.
 *  - To REMOVE anything:      Delete/comment out the relevant key or array entry.
 *
 * 
 *
 * These are still available in the full LCI grid via envFactorOptions from context.
 * ============================================================
 */

export const PRODUCT_TYPE_CONFIG = {
  "Components for Windows and Curtain Walls": {
    "Glazing": ["Single Glazing", "Double Glazing", "Triple Glazing"],
    "Frames": ["Aluminium Frames", "PVC Frames", "Timber Frames"],
    "Fittings": ["Hardware", "Gaskets", "Seals"],
  },
  // "Building Service Engineering": {
  //   "HVAC": ["Heating", "Ventilation", "Air Conditioning"],
  //   "Electrical": ["Wiring", "Switchgear", "Lighting"],
  //   "Plumbing": ["Pipes", "Fittings", "Fixtures"],
  //   "Renewable Energy": ["Solar Panels", "Heat Pumps", "Wind Turbines"],
  // },
  "Composites": {
    "Fibre Reinforced": ["Glass Fibre", "Carbon Fibre", "Natural Fibre"],
    "Sandwich Panels": ["Metal Faced", "Mineral Wool Core", "Foam Core"],
  },
  "Coverings": {
    "Flooring": ["Carpet", "Vinyl", "Ceramic Tiles", "Hardwood", "Laminate"],
    "Wall Coverings": ["Paint", "Wallpaper", "Tiling", "Cladding"],
    "Roofing": ["Membrane", "Tiles", "Shingles", "Metal Sheets"],
    "Ceilings": ["Suspended", "Direct Fix", "Exposed"],
  },
  "Insulation Materials": {
    "Thermal": ["Mineral Wool", "EPS", "XPS", "Polyurethane", "Natural Fibre"],
    "Acoustic": ["Rockwool", "Foam", "Fiberglass"],
    "Fire Protection": ["Intumescent", "Mineral Board"],
  },
  "Metals": {
    "Steel": ["Structural Steel", "Reinforcing Bar", "Sheet Steel", "Stainless Steel"],
    "Aluminium": ["Extruded", "Sheet", "Cast"],
    "Copper": ["Pipe", "Sheet", "Wire"],
    "Other Metals": ["Zinc", "Lead", "Bronze"],
  },
  "Mineral Building Products": {
    "Concrete": ["Ready-Mix", "Precast", "High Strength"],
    "Masonry": ["Brick", "Block", "Stone"],
    "Gypsum": ["Plasterboard", "Plaster", "Fibre Plaster"],
    "Mortar & Screed": ["Sand / Cement", "Polymer Modified"],
  },
  "Plastics": {
    "Pipes & Fittings": ["PVC", "HDPE", "PP"],
    "Membranes": ["Waterproofing", "Vapour Control", "DPM"],
    "Boards": ["Acrylic", "Polycarbonate"],
  },
  "Wood": {
    "Structural": ["Glulam", "CLT", "LVL", "Solid Timber"],
    "Sheet Materials": ["Plywood", "OSB", "MDF", "Chipboard"],
    "Decking & Cladding": ["Hardwood", "Softwood", "Composite"],
    "Engineered": ["I-Beams", "Finger Jointed"],
  },
  "Reagent": {
    "Adhesives & Sealants": ["Epoxy", "Silicone", "Polyurethane"],
    "Coatings": ["Primers", "Protective Coatings", "Fire Retardants"],
    "Chemicals": ["Cleaning Agents", "Preservatives"],
  },
};

/** Flat list of allowed Types for quick reference / validation */
export const PRODUCT_TYPES = Object.keys(PRODUCT_TYPE_CONFIG);

/** Returns an array of category names for a given type */
export const getCategoriesForType = (type) =>
  type ? Object.keys(PRODUCT_TYPE_CONFIG[type] || {}) : [];

/** Returns an array of sub-category names for a given type + category */
export const getSubCategoriesForType = (type, category) =>
  type && category ? PRODUCT_TYPE_CONFIG[type]?.[category] || [] : [];
